import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Container from '@mui/material/Container'
import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import MenuItem from '@mui/material/MenuItem'
import Menu from '@mui/material/Menu'
import IconButton from '@mui/material/IconButton'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import MoreVertIcon from '@mui/icons-material/MoreVert'

export const TopBar = ({ title, left, menuItems, primaryAction, backOnClick }) => {
  const navigate = useNavigate()
  const [anchorEl, setAnchorEl] = React.useState(null)

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  }

  const handleClose = () => {
    setAnchorEl(null);
  }

  const leftContent = left
    ? left
    : (
        <IconButton
          sx={{
            marginRight: 1
          }}
          onClick={
            backOnClick
            ? () => backOnClick()
            : () => navigate(-1)
          }
        >
          <ArrowBackIcon />
        </IconButton>
    )
  
  return (
    <React.Fragment>
      <Box>
        <IconButton disabled={true} sx={{ py: 2 }}>
          <ArrowBackIcon />
        </IconButton>
      </Box>
      <AppBar sx={{
        position: 'fixed',
        top: '0px !important',
        zIndex: 1100,
        backgroundColor: '#161a20',
      }}
      >
        <Toolbar
          disableGutters={false}
        >
          {leftContent}
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            { title }
          </Typography>
          {menuItems && (
            <div>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleMenu}
                color="inherit"
              >
                <MoreVertIcon />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                onClick={handleClose}
              >
                {menuItems.map((item, index) => {
                  return <MenuItem key={index} {...item}>{item.name}</MenuItem>
                })}
              </Menu>
            </div>
          )}
          {primaryAction}
        </Toolbar>
      </AppBar>
    </React.Fragment>
  )
}

export default TopBar
